var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteShare = function SvgWhiteShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "share@svg")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons/Button-MD-right-icon",
    transform: "translate(-227.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(209.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8709309,14.8258464 C17.8709309,14.1422526 18.0174153,11.4444987 15.8893229,9.30419922 C14.4570312,7.86376953 12.3134765,7.61393229 9.74999994,7.5 L9.74999994,3.91089623 C9.74999994,3.56571826 9.47017791,3.28589623 9.12499994,3.28589623 C8.96974142,3.28589623 8.82004081,3.34368363 8.70505216,3.44800438 L2.75499732,8.84605218 C2.49934921,9.07798294 2.4801225,9.4732437 2.71205325,9.72889181 C2.72422666,9.74231008 2.73697776,9.75519268 2.75027043,9.76750311 L8.70032527,15.2778892 C8.95358046,15.5124305 9.34901768,15.49726 9.58355902,15.2440048 C9.69055746,15.128469 9.74999994,14.9768013 9.74999994,14.8193301 L9.74999994,11.25 L9.74999994,11.25 C11.3776041,11.2947591 12.5369753,11.398288 13.590332,11.7333984 C15.1070422,12.2159182 16.2791759,13.5849066 17.106733,15.8403636 C17.1970955,16.0864178 17.4313617,16.25 17.6934839,16.25 L17.8749999,16.25 L17.8749999,16.25 C17.8749999,15.8390299 17.8709309,15.1879883 17.8709309,14.8258464 Z",
    id: "Shape",
    fill: "#FFFFFF",
    transform: "translate(10.062500, 9.375000) scale(-1, 1) translate(-10.062500, -9.375000) "
  })))))));
};
export default SvgWhiteShare;